import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { X, Utensils, GraduationCap } from "lucide-react";

const navItems = [
  { icon: "grid", label: "Dashboard", href: "/dashboard" },
  {
    icon: "store",
    label: "Manage Restaurants",
    href: "/restaurant-management",
  },
  { icon: "users", label: "Manage Staff", href: "/staff-management" },
  { icon: "book-open", label: "Manage Menu", href: "/menu-management" },
  { icon: "history", label: "Previous Menu", href: "/previous-menu" },
  { icon: "award", label: "Team Progress", href: "/lesson-progress" },
  { icon: "graduation-cap", label: "My Lessons", href: "/my-lessons" },
  { icon: "wine-glass", label: "Wine List", href: "/wine-list" },
  { icon: "utensils", label: "Food List", href: "/food-list" },
  { icon: "progress", label: "My Progress", href: "/progress" },
  { icon: "credit-card", label: "Subscription", href: "/subscription" },

];

export default function Sidebar({ isOpen, setIsOpen }) {
  const location = useLocation();
  const navigate = useNavigate();
  const userRole = localStorage.getItem("userRole");
  const user = JSON.parse(localStorage.getItem("userinfo"));

  // useEffect(() => {
  //   if (userRole === 'employee') {
  //     navigate('/my-lessons');
  //   }
  // }, [userRole, navigate]);

  const filteredNavItems = navItems.filter((item) => {
    if (userRole === "super_admin") {
      return !["/wine-list", "/food-list"].includes(item.href);
    } else if (userRole === "manager") {
      return [
        "/dashboard",
        "/plans",
        "/staff-management",
        "/my-lessons",
        "/progress",
        "/subscription",
        "/menu-management",
        "/previous-menu",
        "/lesson-progress",
        "/restaurant-management",
      ].includes(item.href);
    } else if (userRole === "director") {
      return [
        "/dashboard",
        "/plans",
        "/staff-management",
        "/restaurant-management",
        "/menu-management",
        "/previous-menu",
        "/lesson-progress",
        "/my-lessons",
        "/progress",
        "/subscription",

      ].includes(item.href);
    } else if (userRole === "employee") {
      return [
        "/my-lessons",
        "/plans",
        "/menu-management",
        "/progress",
      ].includes(item.href);
    }
    return true;
  });

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-40 z-40 lg:hidden"
          onClick={() => setIsOpen(false)}
        />
      )}

      <div
        className={`fixed top-0 left-0 z-50 w-64 h-screen bg-white border-r border-gray-200 overflow-y-auto overflow-x-hidden transform transition-transform duration-300 
        ${isOpen ? "translate-x-0" : "-translate-x-full"} 
        lg:translate-x-0 lg:sticky lg:top-0 lg:z-0 lg:h-screen`}
      >
        <div className="p-4 border-b border-gray-200 flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <svg
              width="350"
              height="40"
              viewBox="10 0 750 90"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M71.3793 70.4025C70.9175 73.8547 73.2944 73.7369 73.2944 73.7369C73.2944 73.7369 75.5288 74.0159 75.1693 70.3932C75.002 68.6763 73.9824 54.7961 74.1095 48.9081C74.2365 43.0232 74.6146 26.6452 74.6146 26.1555C74.6146 25.0833 73.5702 24.6556 72.6065 26.14C72.6065 26.14 70.2574 29.0128 70.2574 41.9385C70.2574 46.4041 72.4515 44.7307 72.4515 48.9825C72.4546 48.9825 72.1819 64.4432 71.3793 70.4025Z"
                fill="black"
              />
              <path
                d="M34.7093 44.6935C35.4159 36.4937 39.2121 43.5066 36.5098 25.4769C36.4602 25.136 36.2526 24.95 36.203 25.4769C36.1534 25.982 36.1844 35.6508 36.1534 36.0815C36.1193 36.5092 35.4252 36.6114 35.3911 36.0815C35.3601 35.5516 34.8023 26.4035 34.7372 25.4862C34.7093 25.0461 34.4521 25.0151 34.4242 25.4862C34.3932 26.0161 34.0957 35.6446 34.0616 36.0722C34.0461 36.286 33.8695 36.4317 33.6897 36.4534C33.51 36.4317 33.3334 36.286 33.3179 36.0722C33.2838 35.6446 32.9863 26.0161 32.9553 25.4862C32.9274 25.0151 32.6702 25.0461 32.6423 25.4862C32.5772 26.4035 32.0194 35.5516 31.9884 36.0815C31.9543 36.6114 31.2602 36.5092 31.2261 36.0815C31.1951 35.6508 31.2261 25.9789 31.1765 25.4769C31.1269 24.95 30.9193 25.136 30.8697 25.4769C28.1674 43.5066 31.9636 36.4937 32.6671 44.6935C33.3736 52.8903 31.7715 62.5776 31.663 67.8768C31.5484 73.3093 32.4564 73.6068 33.6897 73.6068C34.9231 73.6068 35.8311 73.3093 35.7165 67.8768C35.608 62.5776 34.0058 52.8903 34.7093 44.6935Z"
                fill="black"
              />
              <path
                d="M61.6268 25.2042L61.4161 24.7672H45.5742L45.3573 25.2042C43.4422 29.3072 42.0414 33.6302 41.1861 38.0741C41.0715 38.7156 41.0157 39.3633 41.0126 40.011C41.0126 42.047 41.6479 44.0303 42.8317 45.6852C44.4617 48.0373 46.8231 49.6921 48.7352 51.0712C49.5564 51.6476 50.3404 52.2736 51.0842 52.9429C51.3321 53.1754 51.5459 53.4388 51.7195 53.727C51.8186 53.885 51.8806 54.0679 51.893 54.2538V68.3634C51.8217 69.2249 51.4871 70.0461 50.9354 70.7124C50.3869 71.3879 49.6153 71.8404 48.7569 71.9922L45.5216 72.5315L45.3325 72.5717C45.2829 72.581 45.2365 72.5965 45.19 72.6182C45.128 72.6399 45.0722 72.6709 45.0195 72.7112C44.9483 72.7577 44.8894 72.8166 44.8398 72.8847C44.7406 73.018 44.6879 73.1822 44.691 73.3465C44.691 73.4735 44.722 73.5944 44.7747 73.7091C44.8429 73.8361 44.9421 73.9446 45.066 74.0221C45.1435 74.0654 45.2241 74.0995 45.3077 74.1243C45.3542 74.1274 45.4038 74.1274 45.4503 74.1243H62.1444L62.3334 74.0685C62.4171 74.0252 62.4915 73.9725 62.5596 73.9105C62.6247 73.8516 62.6774 73.7772 62.7177 73.6998C62.7735 73.5882 62.8044 73.4642 62.8044 73.3403C62.8044 73.1729 62.7518 73.0118 62.6557 72.8754C62.5813 72.7794 62.4884 72.6988 62.3799 72.643C62.3303 72.612 62.2745 72.5903 62.2156 72.5779C62.1382 72.5531 62.0607 72.5346 61.9801 72.5253L58.7355 71.9829C57.7841 71.8063 56.9009 71.3662 56.1882 70.7124C55.4909 70.1267 55.0694 69.2744 55.0292 68.3634V54.0586C55.054 53.789 55.1624 53.5317 55.3422 53.3272C56.0363 52.5556 56.8266 51.8707 57.6943 51.2974C59.597 50.033 61.3665 48.5796 62.9842 46.965C64.8498 45.0871 65.9127 42.5552 65.9468 39.9087C65.9437 39.2827 65.8879 38.6598 65.7825 38.0431C64.9272 33.6116 63.5327 29.2979 61.6268 25.2042ZM44.5733 39.6577C44.6105 41.1111 45.2179 42.4902 46.2653 43.5004C47.3561 44.5789 48.5647 45.5302 49.8694 46.336L49.3457 47.12C47.9821 46.2709 46.7147 45.2668 45.5742 44.1357C44.3718 42.9519 43.6746 41.3466 43.6312 39.6577H42.5961C42.6116 39.2208 42.6581 38.7838 42.7294 38.3499C43.2872 35.3811 44.1084 32.4712 45.1838 29.6481C45.6238 28.5046 46.0143 27.5563 46.3056 26.9055C46.4048 26.67 46.4915 26.4902 46.5628 26.3353H60.4275C62.1723 30.1718 63.4614 34.2035 64.261 38.3406C64.3353 38.7776 64.3787 39.2177 64.388 39.6577H44.5733Z"
                fill="black"
              />
              <path
                d="M130.985 48.4159C131.112 48.7103 132.125 51.58 130.818 54.5736C129.299 58.1591 125.038 60.3934 119.723 60.4368C115.128 60.4368 110.95 58.4132 108 55.2058L111.121 52.0851C112.596 54.7006 116.349 56.5569 119.723 56.5569C123.393 56.5135 125.546 55.1655 126.43 53.0551C127.105 51.4932 126.557 49.8074 126.516 49.764C125.63 47.3189 123.182 46.7704 119.723 45.7167C115.803 44.536 111.288 43.5661 109.813 39.4321C109.01 37.2814 109.221 34.7929 110.318 32.7662C112.766 28.1271 119.007 28 119.723 28C124.362 28 128.497 30.0267 131.45 33.2744L128.369 36.3517C126.64 33.8229 123.269 31.883 119.723 31.883C119.683 31.883 115.971 31.883 114.536 34.5822C113.987 35.6358 113.86 37.0273 114.241 38.1243C115.084 40.4454 117.489 40.9908 120.864 42.0042C124.871 43.2283 129.383 44.1549 130.985 48.4159ZM157.348 49.64C157.348 55.8379 152.876 60.4368 146.886 60.4368C144.862 60.4368 142.29 59.5939 140.899 58.4535V70.7687H136.554V39.1779H140.899V40.8235C142.541 39.5591 144.862 38.7999 146.886 38.7999C152.876 38.7999 157.348 43.439 157.348 49.64ZM152.96 49.64C152.96 45.379 150.05 42.3854 146.464 42.3854C144.103 42.3854 142.036 43.439 140.899 45.7167C140.35 46.8541 140.012 48.2052 140.012 49.64C140.012 51.0717 140.35 52.4229 140.899 53.5602C142.036 55.7977 144.103 56.8947 146.464 56.8947C150.05 56.8947 152.96 53.8577 152.96 49.64ZM181.641 49.64V51.1988H165.235C165.235 55.0384 168.904 56.8947 171.603 56.8947C173.586 56.8947 175.777 55.8379 176.958 54.1521L179.955 56.8513C178.563 58.7479 176.286 60.4368 171.603 60.4368C164.853 60.4368 160.723 55.8379 160.723 49.64C160.723 43.439 164.726 38.7999 171.182 38.7999C177.634 38.7999 180.587 42.3854 181.473 47.6133C181.6 48.2889 181.641 48.9645 181.641 49.64ZM165.318 47.6133H177.085C177.085 44.2385 174.386 42.3854 171.182 42.3854C167.974 42.3854 165.318 44.536 165.318 47.6133ZM194.758 38.7565C200.749 38.7565 203.15 42.3854 203.15 45.4626V60.0153H198.809V57.7376C197.29 59.8046 194.591 60.3934 192.902 60.3934C188.136 60.3934 185.015 57.6105 185.015 53.898C185.015 48.7103 188.895 46.8541 192.902 46.8541H198.809V45.4626C198.809 44.1549 198.301 42.342 194.758 42.342C192.775 42.342 190.962 43.3956 189.782 45.0412L186.788 42.342C188.768 40.1479 191.594 38.7565 194.758 38.7565ZM198.809 53.5199V50.3993H193.494C190.919 50.3993 189.106 51.7039 189.403 54.0684C189.654 56.0487 191.257 56.8513 193.494 56.8513C197.501 56.8513 198.809 54.9516 198.809 53.5199ZM223.356 60.0153L215.469 49.9344L213.191 51.8744V60.0153H208.803V28.3812H213.191V46.476L221.583 39.1779H228.333L218.63 47.2755L228.965 60.0153H223.356ZM266.673 28.3812H272.366L259.331 47.446V60.0153H254.652V47.446L241.618 28.3812H247.311L256.97 43.1446L266.673 28.3812ZM279.453 42.3854C275.867 42.3854 272.958 45.379 272.958 49.64C272.958 53.8577 275.867 56.8947 279.453 56.8947C283.035 56.8947 285.948 53.8577 285.948 49.64C285.948 45.379 283.035 42.3854 279.453 42.3854ZM279.453 38.7999C285.44 38.7999 290.29 43.439 290.29 49.64C290.29 55.8379 285.44 60.4368 279.453 60.4368C273.463 60.4368 268.613 55.8379 268.613 49.64C268.613 43.439 273.463 38.7999 279.453 38.7999ZM294.635 51.1988V39.1779H298.979V50.7773C298.979 54.995 300.287 56.8513 303.873 56.8513C307.92 56.8513 309.566 54.0251 309.566 50.3559V39.1779H313.91V60.0153H309.566V56.6406C308.977 58.4968 306.361 60.1827 303.873 60.3531C298.22 60.7746 294.635 58.032 294.635 51.1988ZM332.343 39.4321L331.413 42.8471C331.119 42.6798 330.192 42.3854 329.433 42.3854C325.847 42.3854 324.159 45.8004 324.159 50.0181V60.0153H319.817V39.1779H324.159V42.1312C324.667 40.1913 326.901 38.7999 329.39 38.7999C330.53 38.7999 331.751 39.0943 332.343 39.4321ZM384.095 28.3812H384.768V60.0153H380.089V36.268L367.897 60.0153H365.241L353.053 36.268V60.0153H348.371V28.3812H354.023L366.549 52.8443L379.075 28.3812H384.095ZM410.75 49.64V51.1988H394.344C394.344 55.0384 398.013 56.8947 400.712 56.8947C402.695 56.8947 404.889 55.8379 406.07 54.1521L409.064 56.8513C407.672 58.7479 405.395 60.4368 400.712 60.4368C393.966 60.4368 389.832 55.8379 389.832 49.64C389.832 43.439 393.839 38.7999 400.291 38.7999C406.743 38.7999 409.696 42.3854 410.582 47.6133C410.709 48.2889 410.75 48.9645 410.75 49.64ZM394.427 47.6133H406.197C406.197 44.2385 403.495 42.3854 400.291 42.3854C397.086 42.3854 394.427 44.536 394.427 47.6133ZM434.243 47.9945V60.0153H429.901V48.4159C429.901 44.1983 428.593 42.342 425.008 42.342C420.958 42.342 419.312 45.1682 419.312 48.8374V60.0153H414.967V39.1779H419.312V42.5527C419.904 40.6964 422.519 39.0106 425.008 38.8402C430.657 38.4187 434.243 41.1613 434.243 47.9945ZM439.728 51.1988V39.1779H444.073V50.7773C444.073 54.995 445.377 56.8513 448.963 56.8513C453.013 56.8513 454.659 54.0251 454.659 50.3559V39.1779H459.004V60.0153H454.659V56.6406C454.067 58.4968 451.451 60.1827 448.963 60.3531C443.313 60.7746 439.728 58.032 439.728 51.1988Z"
                fill="black"
              />
              <path
                d="M18.5 92C18.7027 92 18.9054 91.9328 19.1081 91.8655C22.0135 90.3861 30.1892 86.4185 33.027 86.4185C33.2297 86.4185 33.2973 86.4185 33.3649 86.4185C39.5135 89.7136 46.473 91.462 53.5 91.462C76.9459 91.462 96 72.4984 96 49.231C96 25.9636 76.9459 7 53.5 7C30.0541 7 11 25.9636 11 49.231C11 59.1835 14.5135 68.7998 20.9324 76.3987C21.3378 77.8109 19.3784 84.6028 17.2162 90.1843C17.0135 90.7223 17.1487 91.3275 17.5541 91.6638C17.8919 91.8655 18.1622 92 18.5 92ZM53.5 9.68987C75.4595 9.68987 93.2973 27.443 93.2973 49.231C93.2973 71.019 75.4595 88.7722 53.5 88.7722C46.9459 88.7722 40.3919 87.1582 34.6487 84.0649C34.2432 83.8631 33.7027 83.7286 33.0946 83.7286C30.2568 83.7286 24.5811 86.2168 21 87.9652C23.5676 80.568 24.3108 76.197 23.1622 74.7848C17.0811 67.6566 13.7703 58.5783 13.7703 49.2983C13.7027 27.443 31.5405 9.68987 53.5 9.68987Z"
                fill="black"
              />
            </svg>
          </div>
          <button className="lg:hidden" onClick={() => setIsOpen(false)}>
            <X className="w-5 h-5 text-gray-700" />
          </button>
        </div>
        <nav className="p-[0.8rem] flex flex-col h-[calc(100%-80px)]">
          <ul className="space-y-2 flex-grow">
            {filteredNavItems.map((item) => {
              const isActive = location.pathname === item.href;
              return (
                <li key={item.label}>
                  <Link
                    to={item.href}
                    className={`flex items-center space-x-3 p-2 rounded-md ${isActive
                      ? "bg-textcolor text-white font-medium"
                      : "text-gray-700 hover:bg-gray-100"
                      }`}
                  >
                    <span className="flex-shrink-0 w-5 h-5">
                      {item.icon === "grid" && (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <rect width="7" height="7" x="3" y="3" rx="1" />
                          <rect width="7" height="7" x="14" y="3" rx="1" />
                          <rect width="7" height="7" x="14" y="14" rx="1" />
                          <rect width="7" height="7" x="3" y="14" rx="1" />
                        </svg>
                      )}
                      {item.icon === "store" && (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7" />
                          <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
                          <path d="M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4" />
                          <path d="M2 7h20" />
                          <path d="M22 7v3a2 2 0 0 1-2 2v0a2 2 0 0 1-2-2v0" />
                          <path d="M18 12v0a2 2 0 0 1-2-2v0" />
                          <path d="M14 12v0a2 2 0 0 1-2-2v0" />
                          <path d="M10 12v0a2 2 0 0 1-2-2v0" />
                          <path d="M6 12v0a2 2 0 0 1-2-2v0" />
                          <path d="M2 7v3a2 2 0 0 0 2 2v0" />
                        </svg>
                      )}
                      {item.icon === "users" && (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                          <circle cx="9" cy="7" r="4" />
                          <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                        </svg>
                      )}
                      {item.icon === "book-open" && (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
                          <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
                        </svg>
                      )}
                      {item.icon === "history" && (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          viewBox="0 0 24 24"
                        >
                          <path d="M3 12a9 9 0 1 0 9-9" />
                          <polyline points="3 7 3 12 8 12" />
                        </svg>
                      )}
                      {item.icon === "award" && (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <circle cx="12" cy="8" r="6" />
                          <path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11" />
                        </svg>
                      )}
                      {item.icon === "graduation-cap" && (
                        <GraduationCap size={20} />
                      )}
                      {item.icon === "credit-card" && (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <rect width="20" height="14" x="2" y="5" rx="2" />
                          <line x1="2" x2="22" y1="10" y2="10" />
                        </svg>
                      )}
                      {item.icon === "wine-glass" && (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          viewBox="0 0 24 24"
                        >
                          <path d="M8 22h8" />
                          <path d="M12 22v-7" />
                          <path d="M7 10a5 5 0 0 0 10 0V5H7v5Z" />
                        </svg>
                      )}
                      {item.icon === "utensils" && <Utensils size={20} />}
                      {item.icon === "progress" && (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          viewBox="0 0 24 24"
                        >
                          <rect x="2" y="7" width="20" height="10" rx="2" />
                          <rect
                            x="6"
                            y="11"
                            width="6"
                            height="2"
                            rx="1"
                            fill="currentColor"
                          />
                        </svg>
                      )}
                      {item.icon === "plan" && (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M3 3h18v18H3z" />
                          <path d="M3 9h18" />
                          <path d="M9 21V9" />
                        </svg>
                      )}
                    </span>
                    <span>
                      {item.label === "Menu Management" &&
                        userRole === "employee"
                        ? "Menu"
                        : item?.label}
                    </span>
                  </Link>
                </li>
              );
            })}
          </ul>

          {/* Upgrade Card */}
          {userRole !== "super_admin" || userRole !== "employee" || user?.current_subscription?.plan === "Free trial" && (
            <div className="mt-6 bg-[#FEF3D7] rounded-3xl p-5 text-center flex flex-col items-center">
              <h4 className="text-[#881337] font-bold text-lg mb-2">
                Upgrade to Pro
              </h4>
              <p className="text-gray-600 text-sm leading-snug mb-4">
                Unlock advanced features and reporting.
              </p>
              <Link
                to="/plans"
                className="w-full bg-[#881337] text-white py-2.5 rounded-xl font-medium hover:bg-[#6e0f2c] transition-colors text-sm"
              >
                Learn More
              </Link>
            </div>
          )}
        </nav>
      </div>
    </>
  );
}
